import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    faqs: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
  customSchema: null,
};

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    faqStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign, customSchema } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};
      state.customSchema = customSchema ?? null;

      state.blockContent = {
        faqs: blockContent.faqs ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    faqClear: () => initialState,

    faqUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    faqUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    faqUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    faqUpdateCustomSchema: (state, action) => {
      state.customSchema = action.payload ?? null;
    },
  },
});

export const { faqStore, faqClear, faqUpdateIsLoading, faqUpdateIsActive, faqUpdateBlockContent, faqUpdateCustomSchema } = faqSlice.actions;

export const selectFaqIsLoading = (state) => state.faq.isLoading;

export const selectFaqId = (state) => state.faq.id;
export const selectFaqUID = (state) => state.faq.uid;
export const selectFaqSID = (state) => state.faq.sid;

export const selectFaqBlockContent = (state) => state.faq.blockContent;
export const selectFaqSortItems = createSelector([selectFaqBlockContent], ({ faqs }) => {
  return sortItems(faqs);
});
export const selectFaqItemDesign = (state) => state.faq.itemDesign;
export const selectFaqContainerDesign = (state) => state.faq.containerDesign;
export const selectFaqCustomSchema = (state) => state.faq.customSchema;

export default faqSlice.reducer;
